import { useEffect, useRef } from "react";

const PREFIX = "message-";

/** The element id (and URL hash) of a saved message, for links to it ("Copy link to message"). */
export const messageAnchor = (uuid: string) => `${PREFIX}${uuid}`;

/**
 * Opened from a link to one of its messages (`#message-<uuid>`), the chat scrolls to it once it has loaded, instead of
 * to the end. Each link is followed once, so new messages arriving afterwards scroll as usual.
 */
export function useScrollToLinkedMessage(loaded: boolean, reveal: (element: HTMLElement) => void) {
  const hash = globalThis.location.hash;
  const followed = useRef<string | null>(null);
  useEffect(() => {
    if (!loaded || !hash.startsWith(`#${PREFIX}`) || followed.current === hash) return;
    const target = document.getElementById(hash.slice(1));
    if (!target) return;
    followed.current = hash;
    reveal(target);
  }, [loaded, hash, reveal]);
}
